import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

const investmentTransactions = (account) => {
  const postedOnDate = DateTime.local().minus({ days: 1 });
  const postedOn = postedOnDate.toISODate();

  const defaultProps = () => ({
    source: 'QCS_REFRESH',
    accountId: account?.id,
    postedOn,
    payee: 'Aggregated Txn 2900',
    coa: {
      type: 'UNCATEGORIZED',
    },
    acquisitionOn: DateTime.local().minus({ months: 1 }).toISODate(),
    currency: 'USD',
    state: 'CLEARED',
    knownCategoryId: '4500900000',
    cpData: {
      id: uuidv4(),
      postedOn,
      txnOn: postedOn,
      payee: 'Aggregated Txn 1',
      inferredPayee: 'Aggregated Txn 1',
      inferredCoa: {
        type: 'UNCATEGORIZED',
      },
      cpCategoryId: '1207',
    },
    type: 'INVESTMENT',
    securityId: 'QEXP-2',
    securityIdType: 'CUSIP',
    // localSecurityId,
  });

  return [
    {
      ...defaultProps(),
      investmentTxnType: 'BUY',
      units: 11,
      commission: -0.12,
      costBasis: 11 * -12.34 - 0.12,
      amount: 11 * -12.34 - 0.12,
      securityType: 'STOCK',
      symbol: 'AAPL',
      securityName: 'Apple Inc',
      cpData: {
        ...defaultProps().cpData,
        amount: 11 * -12.34 - 0.12,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'SELL',
      units: 2,
      commission: -0.1,
      amount: 2 * 56.78 - 0.1,
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      cpData: {
        ...defaultProps().cpData,
        amount: 2 * 56.78 - 0.1,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'STOCK_DIVIDEND',
      units: 2,
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      cpData: {
        ...defaultProps().cpData,
        units: 2,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'REINVEST_DIVIDEND',
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      units: 10,
      commission: -0.1,
      costBasis: 10 * -11.22,
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'REINVEST_INTEREST',
      securityType: 'STOCK',
      symbol: 'AMZN',
      securityName: 'Amazon Inc',
      units: 2,
      commission: -0.01,
      costBasis: 2 * -3.4,
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'REINVEST_CAPITAL_GAIN_LONG',
      securityType: 'STOCK',
      symbol: 'APPL',
      securityName: 'Apple Inc',
      units: 3,
      commission: -0.1,
      costBasis: 3 * -5.06,
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'REINVEST_CAPITAL_GAIN_SHORT',
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      units: 10,
      commission: -0.1,
      costBasis: 10 * -11.22,
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'INCOME_DIVIDEND',
      symbol: 'INTU',
      amount: 123.45,
      cpData: {
        ...defaultProps().cpData,
        amount: 123.45,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'INCOME_INTEREST',
      symbol: 'PYPL',
      amount: 11.22,
      cpData: {
        ...defaultProps().cpData,
        amount: 11.22,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'CAPITAL_GAIN_LONG',
      symbol: 'TSLA',
      amount: 22.33,
      cpData: {
        ...defaultProps().cpData,
        amount: 22.33,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'CAPITAL_GAIN_SHORT',
      symbol: 'GOOG',
      amount: 44.55,
      cpData: {
        ...defaultProps().cpData,
        amount: 44.55,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'INCOME_MISCELLANEOUS',
      symbol: 'FB',
      amount: 55.66,
      cpData: {
        ...defaultProps().cpData,
        amount: 55.66,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'ADD_SHARES',
      symbol: 'F',
      units: 12,
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'REMOVE_SHARES',
      symbol: 'F',
      units: -10,
      cpData: {
        ...defaultProps().cpData,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'BUY_BONDS',
      symbol: '^FVX',
      units: 20000,
      commission: -0.1,
      amount: -19877.0,
      securityId: 'QEXP-55',
      securityIdType: 'CUSIP',
      cpData: {
        ...defaultProps().cpData,
        amount: -19877.0,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'SELL_BONDS',
      symbol: '^IRX',
      units: 10000,
      amount: 9980.0,
      securityId: 'QEXP-55',
      securityIdType: 'CUSIP',
      cpData: {
        ...defaultProps().cpData,
        amount: 9980.0,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'EXPENSE_MARGIN_INTEREST',
      amount: -15.25,
      cpData: {
        ...defaultProps().cpData,
        amount: -15.25,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'EXPENSE_MISCELLANEOUS',
      amount: -16.25,
      cpData: {
        ...defaultProps().cpData,
        amount: -16.25,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'RETURN_OF_CAPITAL',
      amount: -17.25,
      cpData: {
        ...defaultProps().cpData,
        amount: -17.25,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'SHORT_SELL',
      units: 3,
      commission: -0.11,
      amount: 3 * 58.78 - 0.11,
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      cpData: {
        ...defaultProps().cpData,
        amount: 3 * 58.78 - 0.11,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'COVER_SHORT_SELL',
      units: 3,
      commission: -0.12,
      costBasis: 11 * -12.34 - 0.12,
      amount: 3 * -12.34 - 0.12,
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      cpData: {
        ...defaultProps().cpData,
        amount: 3 * -12.34 - 0.12,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'STOCK_SPLIT',
      units: +27, // before=3, after=30 : 3 * 10 / 1 - 3 = +27
      amount: 0,
      securityType: 'STOCK',
      symbol: 'INTU',
      securityName: 'Intuit Inc',
      splitNumerator: 10, // 10 for 1
      splitDenominator: 1, // 10 for 1
      cpData: {
        ...defaultProps().cpData,
        amount: 0,
      },
    },
    {
      ...defaultProps(),
      investmentTxnType: 'STOCK_SPLIT',
      units: -27, // before=30, after=3 : 30 * 1 / 10  - 30 = -27
      amount: 0,
      securityType: 'STOCK',
      symbol: 'AAPL',
      securityName: 'Apple Inc',
      splitNumerator: 1, // 1 for 10
      splitDenominator: 10, // 1 for 10
      cpData: {
        ...defaultProps().cpData,
        amount: 0,
      },
    },
    {
      source: 'QCS_REFRESH',
      accountId: account?.id,
      postedOn,
      payee: 'Some Payee',
      coa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      amount: -12.34,
      state: 'CLEARED',
      matchState: 'NOT_MATCHED',
      cpData: {
        id: uuidv4(),
        cpPendingId: uuidv4(),
        postedOn,
        txnOn: postedOn,
        amount: -12.34,
        inferredPayee: 'Some Payee',
        inferredCoa: {
          type: 'UNCATEGORIZED',
          id: '0',
        },
        cpCategoryId: '2002',
      },
      type: 'CASH_FLOW',
    },
  ];
};

export default investmentTransactions;
